import { inject, PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import FormModel from '../../../../models/Form';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import BooleanFieldItem from '../../../../types/BooleanFieldItem';
import RadioField from '../../../form/RadioField';

const CheckoutMethodSelector = ({
  checkoutStore,
  form,
  onChange,
  options,
  field,
  fieldName,
  content,
}) => {
  const { order } = checkoutStore;
  const selectorField = form.getField(field);

  const handleChange = (_, option) => {
    if (fieldName === 'shippingMethodList') {
      order.setScrollToMethodId(
        `CheckoutShippingMethodContent-${option.value}`.toLowerCase()
      );
    }

    if (fieldName === 'paymentMethod') {
      order.setScrollToMethodId(
        `CheckoutPaymentMethodContent-${option.value}`.toLowerCase()
      );
    }

    onChange(option);
  };

  return (
    <div className="CheckoutMethodSelector">
      <RadioField
        field={selectorField}
        fieldName={fieldName}
        options={options}
        formName={'checkout'}
        required={selectorField.required}
        onChange={handleChange}
        inline={false}
        content={content}
        validate={false}
      />
    </div>
  );
};

CheckoutMethodSelector.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  form: modelOf(FormModel).isRequired,
  field: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([
    BooleanFieldItem,
    PropTypes.arrayOf(BooleanFieldItem),
    MobxPropTypes.observableArrayOf(BooleanFieldItem),
  ]).isRequired,
  content: PropTypes.func,
};

export default inject('checkoutStore')(observer(CheckoutMethodSelector));
